import axios from 'axios'
// URL de la API
const baseURL = process.env.VUE_APP_BASE_URL_API

// Objeto axios de la api de tipo
const apiTipo = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  //timeout: 10000, // 10 segundos de espera
})

export default {
  /**
   * @name getTipo
   * @description Obtienen una lista de Tipos
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  getTipo(jwt, params) {
    apiTipo.defaults.headers.common['Authorization'] = 'Bearer ' + jwt

    if (params != null) {
      return apiTipo.get('tipo/' + params)
    }
    return apiTipo.get('tipo/')
  },

  /**
   * @name postTipo
   * @description Se crea el tipo
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  postTipo(jwt, body) {
    apiTipo.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return apiTipo.post('tipo', body)
  },

  /**
   * @name putTipo
   * @description Se actualiza el tipo
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  putTipo(jwt, body, id) {
    apiTipo.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return apiTipo.put('tipo/' + id, body)
  },
  /**
   * @name deleteTipo
   * @description Se actualiza el tipo
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  deleteTipo(jwt, body, id) {
    apiTipo.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return apiTipo.delete('tipo/' + id, body)
  },
}
